import router from "./index.js";
import systemInfo from "@/utils/systemInfo";
import toolFunction from '@/utils/toolFunction'
export function routerBeforeEach() {
  router.beforeEach((to, from, next) => {
    const name = to.name;
    systemInfo.setTenantPlat('saas');
    const { tenant: query_tenant } = to.query || {};
    const session_tenant = systemInfo.getTenant();
    if (name === 'home') {
      if (
        // token 不存在 重新登录,或者问号参数上的租户和本地租户不一样时也要重新登录
        !systemInfo.getToken() ||
        query_tenant !== session_tenant
      ) {
        const _tenant = query_tenant || session_tenant
        systemInfo.setTenant(_tenant);
        toolFunction.oidcLogin({
          tenant: _tenant
        });
      } else {
        next();
      }
    } else {
      next();
    }

  });
}



// WEBPACK FOOTER //
// ./src/router/before_each.js